import React from 'react'
import './SampleLoading.css'

const SampleLoading = () => {
  return (
    <span className="my_animate color-or p-5" style={{fontSize:"25px"}}><strong>Loading...</strong></span>
  )
}

export default SampleLoading